<template>
  <div class="progress-wrap lb-side-left mt-1">
    <div
      class="progress-lb-wrap"
      :id="data.id"
      v-b-tooltip.hover :title="data.title"
    >
      <label class="progress-label mnw-50p">{{data.number}}</label>
      <div class="progress progress-bar-rounded progress-bar-xs">
        <div class="progress-bar" :class="data.class" :style="{
            width: `${data.progress}%`,
            backgroundColor: `${data.color}`
        }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        data:{
            type:Object,
            required:true
        }
    }
}
</script>